import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IS_WHITE_LABEL } from '@/shared/lib/environments';
import { AuthForm } from '@/shared/types/Cognito';

// TODO: move CognitoUser to User slice
type CognitoUser = {
  email: string;
  isAuthorized: boolean;
  password: string;
  metadata: {
    picture: string;
    name: string;
    emailVerified: boolean;
    isUsedSocialProviders: boolean;
    cognitoId: string;
  };
};
type InitialState = {
  type: AuthForm;
  cognitoUser: CognitoUser;
};

// TODO: some fields are not needed at the level of the entire app - move them to local states
const initialState: InitialState = {
  type: IS_WHITE_LABEL ? AuthForm.Signin : AuthForm.Signup,
  cognitoUser: {
    email: '',
    isAuthorized: false,
    password: '',
    metadata: {
      picture: '',
      name: '',
      cognitoId: '',
      emailVerified: false,
      isUsedSocialProviders: false,
    },
  },
};
const cognitoSlice = createSlice({
  name: 'cognito',
  initialState,
  reducers: {
    setAuthForm: (state, { payload }: PayloadAction<AuthForm>) => {
      state.type = payload;
      return state;
    },
    setCognitoUserEmail: (state, { payload }: PayloadAction<CognitoUser['email']>) => {
      state.cognitoUser.email = payload;
    },
    setCognitoUserPassword: (state, { payload }: PayloadAction<CognitoUser['password']>) => {
      state.cognitoUser.password = payload;
    },
    setCognitoUserAuthorized: (state) => {
      state.cognitoUser.isAuthorized = true;
    },
    setCognitoUserMetadata: (state, { payload }: PayloadAction<CognitoUser['metadata']>) => {
      state.cognitoUser.metadata = {
        ...state.cognitoUser.metadata,
        ...payload,
      };
    },
  },
});
export const cognitoReducer = cognitoSlice.reducer;
export const {
  setAuthForm,
  setCognitoUserEmail,
  setCognitoUserAuthorized,
  setCognitoUserPassword,
  setCognitoUserMetadata,
} = cognitoSlice.actions;
